export function xorCrypt(str: string, key: number = 6) {
  let output = ''

  for (let i = 0; i < str.length; ++i) {
    output += String.fromCharCode(key ^ str.charCodeAt(i))
  }

  return output
}
